import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const ticketConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default ticketConfig;
